import React, { useEffect, useState } from "react";
import { InputAdornment, TextField, ThemeProvider, createTheme, debounce } from "@mui/material";
import { useDebounce } from "../../hooks/useDebounce";
import MagnifierIcon from "../../assets/icons/MagnifierIcon";
import colors from "../../themes/colors";

type TableToolbarSearchProps = {
  placeholder?: string;
  value?: string;
  width?: string; 
  onChange?: (value?: string) => void;
};

const TableToolbarSearch = ({ placeholder, value, width = "400px", onChange = () => { }}: TableToolbarSearchProps) => {
  const [search, setSearch] = useState(value);

  const debouncedOnChange = useDebounce(() => onChange(search), 300);

  const handleChange = (event: any) => {
    setSearch(event.target.value);
    debouncedOnChange();
  };

  useEffect(() => {
    setSearch(value);
  }, [value]);

  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: colors.secondary.gray30,
            color: colors.secondary.gray70,
            border: `1px solid ${colors.secondary.gray40}`,
            borderRadius: 4,
            padding: 8
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <TextField
        sx={{ width: width, borderRadius: "4px" }}
        placeholder={placeholder}
        value={search}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <MagnifierIcon color={colors.secondary.gray70} />
            </InputAdornment>
          )
        }}
      />
    </ThemeProvider>
  );
};

export default TableToolbarSearch;